import React from 'react';
import { motion } from 'framer-motion';
import { SearchIcon, MessageCircleIcon, PhoneIcon, MailIcon } from 'lucide-react';
export function SupportHero() {
  return <div className="relative bg-gradient-to-br from-[#132C53] to-[#1e4278] text-white overflow-hidden" data-id="element-6783">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-6784">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')] bg-repeat" data-id="element-6785"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-32" data-id="element-6786">
        <div className="text-center max-w-4xl mx-auto" data-id="element-6787">
          {/* Badge */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6 border border-white/20 shadow-lg" data-id="element-6788">
            <div className="w-2 h-2 rounded-full bg-[#21A366] animate-pulse" data-id="element-6789" />
            <span className="text-sm font-medium text-white tracking-wide" data-id="element-6790">
              Suport dedicat
            </span>
          </motion.div>

          {/* Heading - matching Career3 style */}
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-4xl md:text-6xl lg:text-7xl font-extrabold tracking-tight mb-6 text-white" data-id="element-6791">
            Ai întrebări? <br className="hidden md:block" data-id="element-6792" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#357BEB] to-[#21A366]" data-id="element-6793">
              Suntem aici pentru tine.
            </span>
          </motion.h1>

          {/* Paragraph - matching Career3 style */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-lg md:text-2xl text-gray-300 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-6794">
            Găsește răspunsuri rapide în baza noastră de cunoștințe sau
            contactează-ne direct prin telefon, WhatsApp sau email.
          </motion.p>

          {/* Contact Options */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="space-y-6" data-id="element-6795">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 max-w-3xl mx-auto" data-id="element-6796">
              <a href="tel:0733355359" className="flex items-center justify-center space-x-2 px-4 py-3 rounded-xl text-white bg-white/10 hover:bg-white/20 border border-white/10 backdrop-blur-sm transition-all duration-300 hover:border-white/30 group" data-id="element-6797">
                <PhoneIcon className="w-5 h-5 group-hover:scale-110 transition-transform" data-id="element-6798" />
                <span className="font-semibold" data-id="element-6799">Sună</span>
              </a>

              <a href="https://wa.me/40733355359" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center space-x-2 px-4 py-3 rounded-xl text-white bg-white/10 hover:bg-white/20 border border-white/10 backdrop-blur-sm transition-all duration-300 hover:border-white/30 group" data-id="element-6800">
                <MessageCircleIcon className="w-5 h-5 group-hover:scale-110 transition-transform" data-id="element-6801" />
                <span className="font-semibold" data-id="element-6802">WhatsApp</span>
              </a>

              <a href="mailto:office@cautlocuinta.ro" className="flex items-center justify-center space-x-2 px-4 py-3 rounded-xl text-white bg-white/10 hover:bg-white/20 border border-white/10 backdrop-blur-sm transition-all duration-300 hover:border-white/30 group" data-id="element-6803">
                <MailIcon className="w-5 h-5 group-hover:scale-110 transition-transform" data-id="element-6804" />
                <span className="font-semibold" data-id="element-6805">Email</span>
              </a>
            </div>

            {/* Contact Details */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-center sm:space-x-6 space-y-2 sm:space-y-0 text-sm text-gray-400" data-id="element-6806">
              <div className="flex items-center justify-center space-x-2" data-id="element-6807">
                <PhoneIcon className="w-4 h-4" data-id="element-6808" />
                <span data-id="element-6809">0733 355 359</span>
              </div>
              <div className="flex items-center justify-center space-x-2" data-id="element-6810">
                <MailIcon className="w-4 h-4" data-id="element-6811" />
                <span data-id="element-6812">office@cautlocuinta.ro</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Decorative blur elements */}
      <div className="absolute -top-10 -right-10 w-64 h-64 bg-[#357BEB] rounded-full blur-3xl opacity-20" data-id="element-6813"></div>
      <div className="absolute -bottom-10 -left-10 w-64 h-64 bg-[#21A366] rounded-full blur-3xl opacity-20" data-id="element-6814"></div>
    </div>;
}